'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReactClass2.default)({
    displayName: 'ExclamationMark',

    PropTypes: {
        width: _propTypes2.default.number,
        height: _propTypes2.default.number,
        className: _propTypes2.default.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            width: 18,
            height: 18,
            className: ''
        };
    },
    render: function render() {
        var _props = this.props,
            width = _props.width,
            height = _props.height,
            className = _props.className;


        return _react2.default.createElement(
            'svg',
            { 'data-hook': 'error', tabIndex: '-1', className: className, width: width, height: height, viewBox: '0 0 18 18' },
            _react2.default.createElement(
                'g',
                { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                _react2.default.createElement('circle', { fill: '#D7233E', cx: '9', cy: '9', r: '9' }),
                _react2.default.createElement('polygon', { fill: '#FFFFFF', points: '8 4 8 10 10 10 10 4' }),
                _react2.default.createElement('polygon', { fill: '#FFFFFF', points: '8 12 8 14 10 14 10 12' })
            )
        );
    }
});